import rest from "@/rest-client";

/**
 * Saklama süresi önerisi — K5: süreç×kaynak seviyesinde kalır. TKP-27 / 6.3: kaynak, formun düzenlediği süreç×kaynak
 * kaydından (`datasource` payload'u) okunur; filtredeki kaynak kriteri 6.2'de kalktı. Süreç: kaydın süreci, yoksa filtre.
 */
const idOf = (x) => (x && x._id ? x._id : x) || undefined;

export const storageRecommendationContext = (datasource, criteria = {}) => ({
  datasourceId: idOf(datasource),
  processId: idOf(datasource?.process) ?? idOf(criteria.process),
});

export const storageRecommendation = {
  state: {
    recommendation: null,
  },
  getters: {
    recommendation: (state) => state.recommendation,
  },
  mutations: {
    recommendation: (state, value) => (state.recommendation = value),
  },
  actions: {
    async recommendStoragePeriod({ commit, rootGetters }, { datasource } = {}) {
      commit("isLoading", true);
      try {
        const ctx = storageRecommendationContext(datasource, rootGetters["inventoryFilter/criteria"]);
        commit("recommendation", undefined);
        if (ctx.processId) {
          const response = await rest.post(`/recommendation/paginate/process-datasource-storage-period`, ctx);
          commit("recommendation", response.data);
          return response;
        }
      } finally {
        commit("isLoading", false);
      }
    },
  },
};
